import React, {FC, useEffect} from 'react';
import styles from './FromEmail.module.css';
import WhiteLogoIcon from "../../../assets/images/whiteLogo";
import Bg2Icon from "../../../assets/images/bg2";
import {t, useQuery} from 'utils';
import texts from "../Plan/texts";
import {Link} from "react-router-dom";
import {routes} from "../../../routes";
import {setRefreshToken} from "../../../modules/auth/actions";
import {useDispatch, useSelector} from "react-redux";
import {Api} from "../../../services/api";
import {getUserInfo} from "../../../modules/user/actions";
import {history} from "../../../services/history";
import {RootState} from "../../../types";
import Loader from 'react-loader-spinner';

export const FromEmailPage: FC = () => {
  const dispatch = useDispatch();
  const urlToken = useQuery().get('token') || '';
  const {userInfo, loading} = useSelector((state: RootState) => state.user);


  if(urlToken) {
    Api.setAuthToken(urlToken);
    dispatch(setRefreshToken(urlToken));
  }

  useEffect(() => {
    dispatch(getUserInfo.request());
  }, []);

useEffect(() => {
  if(userInfo && userInfo.country && userInfo.country.length) {
    if(
      userInfo.country[0].short_name === 'AU' ||
      userInfo.country[0].short_name === 'US'
    ) {
      //do nothing
    } else {
      history.push(routes.upgradeEUOnlinePlan);
    }

  }
}, [userInfo]);

  return (
    <div className={styles.wrap}>
      {loading ? (<div className={styles.loader}>
          <Loader type="Circles" color="#fff" height={50} width={50} />
      </div>) :
        (
          <>
            <div className={styles.logo}>
              <WhiteLogoIcon/>
            </div>
            <div className={styles.content}>
              <h1 className={styles.contentText}>
                {t(texts.plan.computerHaveInternet)}
              </h1>
              <div className={styles.contentButtons}>
                <Link className={styles.link} to={routes.upgradeOfflinePlan}>
                  <button
                    className={styles.buttonNo}
                  >
                    {t(texts.plan.no)}
                  </button>
                </Link>

                <Link className={styles.link} to={routes.upgradeOnlinePlan}>
                  <button
                    className={styles.buttonYes}
                  >
                    {t(texts.plan.yes)}
                  </button>
                </Link>

              </div>
            </div>
            <div className={styles.bg}/>
            <div className={styles.bg2}>
              <Bg2Icon/>
            </div>
          </>
        )
      }
    </div>
  );
};
